/* eslint-disable */
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { toQueryString } from '../../api-helpers';
import { DashboardTileCategory } from '../dto/dashboard-tile-category';
import { NewsListDto, fixNewsListDtoFromJson } from '../dto/news-list-dto';
import { Priority } from '../dto/priority';

export interface GetDashboardTileGetQueryParams {
  categories?: DashboardTileCategory[];
  priorities?: Priority[];
}

export interface GetDashboardTileGetParams {
  query: GetDashboardTileGetQueryParams;
}

export function httpGetDashboardTileGet(http: HttpClient, data: GetDashboardTileGetParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<NewsListDto[]>;
export function httpGetDashboardTileGet(http: HttpClient, data: GetDashboardTileGetParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<NewsListDto[]>>;
export function httpGetDashboardTileGet(http: HttpClient, data: GetDashboardTileGetParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get<NewsListDto[]>(`{placeholder}/DashboardTile/Get?${toQueryString(data.query)}`, options as any).pipe(
    tap((eventOrDto) => {
      const dto = eventOrDto instanceof HttpResponse ? eventOrDto.body : options.observe === 'events' ? null : eventOrDto as unknown as NewsListDto[];
      dto?.forEach((x, i, a) => fixNewsListDtoFromJson(a[i]));
    })
  );
};

export const urlGetDashboardTileGet = (baseUrl: string, data: GetDashboardTileGetParams) => {
  return `${baseUrl}/DashboardTile/Get?${toQueryString(data.query)}`;
};
